import { FiTrash2, Modal } from '@agrotoken-tech/ui';
import { useTranslation } from '@bcba/react-hooks';
import { deleteStorageFacility } from '../../../../../services/storage-facilities/deleteStorageFacility';
import { useMutation } from '@tanstack/react-query';

interface Props {
  isOpen: boolean;
  onClose: () => void;
  facilityUuid: string;
  onSuccess: () => void;
}

export const DeleteStorageFacilityModal = ({
  isOpen,
  onClose,
  facilityUuid,
  onSuccess,
}: Props) => {
  const { t } = useTranslation();

  const { mutate, isPending } = useMutation({
    mutationFn: () => deleteStorageFacility(facilityUuid),
    onSuccess,
  });

  return (
    <Modal
      title={t('explorer.storageFacilities.deleteFacility.modal.title')}
      text={t('explorer.storageFacilities.deleteFacility.modal.text')}
      isOpen={isOpen}
      onClose={onClose}
      labelBtnConfirm={t('common.delete')}
      onClickConfirm={mutate}
      isLoadingConfirmBtn={isPending}
      labelBtnClose={t('common.cancel')}
      icon={FiTrash2}
      iconVariant="destructive"
    />
  );
};
